<template>
    <b-container class="Brands wrapper" id="Contact">
        <b-row>
            <b-col cols="12">
                <h2 class="tac">{{$t('brands.title')}}</h2>
                <p class="brandsP">{{$t('brands.msg')}}</p>
                <div id="triggerBrands"></div>
            </b-col>
        </b-row>
        <Sendinblue />
        <b-row>
            <b-col class="flexBrands" cols="12">
                <div class="containerBrands">
                    <img class="blocBrands" src="@/assets/imagesHome/hyundaiPower.png" alt="hyundaiPower">
                </div>
                <div class="containerBrands">
                    <img class="blocBrands" src="@/assets/imagesHome/energizer.png" alt="energizer">
                </div>
                <div class="containerBrands">
                    <img class="blocBrands" src="@/assets/imagesHome/jr.png" alt="jr">
                </div>
                <div class="containerBrands">
                    <img class="blocBrands" src="@/assets/imagesHome/bob.png" alt="back office BFTG">
                </div>
                <div class="containerBrands">
                    <img class="blocBrands" src="@/assets/imagesHome/chipperfield.png" alt="chipperfield">
                </div>
                <div class="containerBrands">
                    <img class="blocBrands" src="@/assets/imagesHome/supportSWAP.png" alt="support Swap">
                </div>
                <div class="containerBrands">
                    <img class="blocBrands" src="@/assets/imagesHome/collectionTracteur.png" alt="collection Tracteur">
                </div>
                <div class="containerBrands">
                    <img class="blocBrands" src="@/assets/imagesHome/servicesSWAP.png" alt="services Swap">
                </div>
                <div class="containerBrands">
                    <img class="blocBrands" src="@/assets/imagesHome/mowdirect.png" alt="mowdirect">
                </div>
                <div class="containerBrands">
                    <img class="blocBrands" src="@/assets/imagesHome/capitools.png" alt="capitools">
                </div>
                <div class="containerBrands">
                    <img class="blocBrands" src="@/assets/imagesHome/feider.png" alt="feider">
                </div>
                <div class="containerBrands">
                    <img class="blocBrands" src="@/assets/imagesHome/tck.png" alt="tck">
                </div>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import Sendinblue from "@/components/Sendinblue.vue"

export default {
    name: 'Brands',
    components: {
        Sendinblue
    },
    mounted() {
        const scene2 = this.$scrollmagic.scene({
          triggerElement: '#triggerBrands',
          duration: 500
        })

        .setTween(".blocBrands", 0.5, {opacity:1})
        this.$scrollmagic.addScene(scene2)
    }
}
</script>

<style scoped lang="scss">
@import '@/assets/style/brands.scss';


</style>
